import { CR, idNameItem, jkRestReturn } from './jkInterface';
import { jkLib } from './jkCommon';
import { Sysuser } from './Sysuser-angular';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class LoginService extends Sysuser {
  userKey: string = 'guest';
  companyItem: idNameItem = { id: '', name: '', icon: '', ps1: '', ps2: '', ps3: '' };
  token: string = '';
  //id: string = '';
  get userid(): string {
    return this.UserID;
  };
  set userid(value: string) {
    this.UserID = value;
  };

  get name(): string {
    return this.UserName;
  }
  set name(value: string) {
    this.UserName = value;
  }
  //password: string = '';
  //email: string = '';
  firebaseMail: string = '';
  firebasePassword: string = '';
  isLogin = false;
  //isLogout: boolean;
  autoLogin = true;
  hostName: string = ''; // "mdr.jack168.com:212"
  get host(): string {
    return this.hostName;
  }
  set host(value: string) {
    this.hostName = value;
  }
  get uid(): string {
    return this.userid;
  }
  set uid(value: string) {
    this.userid = value;
  }

  companyListId: string = '';
  companyId: string = '';
  dbname: string = '';
  sysdbname: string = '';
  //customid: string = ''; // AP 客戶代號
  get customid(): string {
    return this.CUSTOMER;
  }
  set customid(value: string) {
    this.CUSTOMER = value;
  }
  envExpireHour: number = 36;//environment.expireHour
  avatarIcon: string = '';
  //appId: string = '';
  expireHour: number = 24 * 3;
  constructor() {
    super();
    this.UserID = '';
    this.UserName = '';

    this.hostName = ''; // "mdr.jack168.com:212"
    this.companyListId = '';
    this.companyId = '';
    this.dbname = '';
    this.sysdbname = '';
    this.avatarIcon = 'assets/icons/avatar.svg';//'https://ionicframework.com/docs/img/demos/avatar.svg';//'assets/icon/avatar.png';
  }
  init(defaultLogin: boolean, appId: string, expireHour: number): void {
    this.userKey = appId; //environment.appId;
    if (expireHour > 0)
      this.envExpireHour = expireHour // environment.expireHour
    else
      this.envExpireHour = 3;
    this.userCreate(defaultLogin);
  }
  private userCreate(defaultLogin: boolean): boolean {
    let result: boolean = true;
    try {
      //User = new Sysuser(); // new UserClass()
      this.loadLocal();
      if (defaultLogin) {
        this.isLogin = true;

      } else {
        if (!this.isLogin) {
          result = false;
        }
      }
    } catch (error: any) {
      result = false;
      console.log(error);
    }
    return result;
  }

  async logIn(id: string, email: string, password: string,

    token: string, autoLogin: boolean, ret: jkRestReturn): Promise<boolean> {
    ret.clear();
    let fetchRet: any;
    this.isLogin = false;




    const body: any = { id, password, email, ps: '' };
    fetchRet = await jkLib.doFetch(this.hostName, '/api/login', '', token, 'post', body);
    if (fetchRet) {
      if (fetchRet.result) {
        ret.ok();
        this.isLogin = true
        let User = fetchRet.obj
        Object.keys(User).forEach((key) => {
          (this as any)[key] = User[key];
        });
        this.name = User.UserName
        this.Password = password

        this.token = fetchRet.data

        this.autoLogin = autoLogin
        this.login(this) // Login
        //this.saveLocal()  this.login 已經存了
        ret.ok();
      } else {
        ret.addResultError(fetchRet.message + CR + fetchRet.errorLog);
      }
    } else {
      ret.addResultError("無法連上主機:" + this.hostName + '/api/login');
    }
    return this.isLogin;

  }
  asignData(x: LoginService) {
    if (x) {
      Object.keys(x).forEach(element => {
        (this as any)[element] = (x as any)[element]
      });
    }
  }
  parse(json: string): boolean {
    if (!json) { return false; }
    const user = JSON.parse(json);
    // merge 兩個option key 值
    Object.keys(user).forEach(key => {
      (this as any)[key] = user[key];
    })

    return true;
  };
  login(login: LoginService): boolean {
    this.asignData(login)
    this.setCookie(this.userid, this.hostName, "", this.envExpireHour);

    this.saveLocal();

    return true;
  };
  setCookie(userid: string, domain: string, path: string, expiredHours: number): void {
    // let expire_days = 1; // 過期日期(天)
    const d = new Date();
    d.setTime(d.getTime() + (expiredHours * 60 * 60 * 1000));
    // let mStr = "name=" + userid + ";expires=" + d.toGMTString() + ';path=/; domain=' + domain;
    const mStr = "userid=" + userid + "; expires=" + d.toUTCString() /* d.toGMTString() 方法已不再使用 */ + '; path=' + path + '; domain=' + domain;
    document.cookie = mStr; // ??? 只存 userid=JACKIE; 之後沒有
    // jkAlert(document.cookie)
  };
  clearCookie(domain: string): void {
    // let expire_days = 1; // 過期日期(天)
    let d = new Date();
    d.setTime(d.getTime() - 1); // 刪除 Cookie, 將 cookie name 的 value 清空, 並將過期時間設定為現在時間 -- 1 即可
    let expires = "expires=" + d.toUTCString();
    document.cookie = "userid=; " + expires + '; domain=' + domain + '; path=/';
    // jkAlert(document.cookie)
  };
  listCookies(): string {
    let theCookies = document.cookie.split(';');
    let aString = '';
    for (let i = 1; i <= theCookies.length; i++) {
      aString += i + ' ' + theCookies[i - 1] + "\n";
    }
    return aString;
  };
  getCookie(cname: string): string {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') { c = c.substring(1); }
      if (c.indexOf(name) === 0) { return c.substring(name.length, c.length); }
    }
    return "";
  };

  saveLocal(): boolean {
    if (!this.autoLogin) { this.Password = ""; };
    let store = { login: this }; // { login: Login }
    let mJSON = JSON.stringify(store);

    localStorage.setItem(this.userKey, mJSON);
    return true;
  };
  loadLocal(): boolean {

    let cachedUserDataString = localStorage.getItem(this.userKey);
    if (!cachedUserDataString)
      return false;
    let store = JSON.parse(cachedUserDataString)
    if (store) {
      //jkLib.cloneObject(store.user, this);  // ^_^ jackie 20250217 remark

      this.asignData(store.login);
    }
    return true;
  };
  /*logOut(id: string, password: string, serverUrl: string): boolean {
    let bRet: boolean;

    return bRet;
  }*/
  logout(domain: string): boolean {
    // DevExpress.ui.dialog.alert("Logout is not implemented in this demo application.");
    if (confirm("你確定要登出嗎？")) {
      this.isLogin = false;
      //this.isLogout = true;
      //this.userid = "";
      //this.password = "";
      this.clearCookie(domain);
      this.saveLocal();
      //this.exitApp();
      return true;
    }
    else {
      return false;
    };
  };
  setCompanyItem(companyItem: idNameItem, companySelected: string): boolean {
    if (companyItem.id === '') {
      //await this.dismissLoadingView(); // this.loadingCtrl.dismiss();
      //alert('選擇的公司代號(' + companySelected + ')不存在!');
      return false;
    }
    //c = this.lstCompany[0];
    this.companyItem = companyItem;
    this.companyListId = companySelected;
    let ps2 = this.companyItem.ps2 || '';
    this.dbname = jkLib.getToken(ps2, ',', 1);
    this.sysdbname = jkLib.getToken(ps2, ',', 2);
    this.customid = jkLib.getToken(ps2, ',', 3);
    if (this.customid === '') {
      alert('companyItem.ps2 token 3 應該設customid');
      this.customid = this.companyItem.ps3 || '';
    }
    if (this.sysdbname === '') {
      alert('companyItem error:' + JSON.stringify(companyItem));
    }
    this.companyId = this.companyItem.id;
    this.hostName = this.companyItem.ps1 || '';
    return true;
  }
}

export let login: LoginService = new LoginService();
